export class AnticipationParams {
	public reelIndex: number = 0;

	public constructor(reelIndex: number) {
		this.reelIndex = reelIndex;
	}
}